/**
 * Тематические кластеры EN-версии: лендинг — хаб темы, статьи блога — её раскрытие.
 *
 * Одна карта питает три места перелинковки, чтобы связи не разъезжались:
 *  - группировку списка /blog по темам;
 *  - блок «Read more» на самом лендинге;
 *  - обратную ссылку со статьи на свой лендинг.
 *
 * Тексты здесь английские без i18n — как и содержимое лендингов
 * (assets/landing/landing-pages.json), которые существуют только в SX-сборке.
 */
export interface LandingCluster {
    /** Сегмент пути лендинга, он же его slug в landing-pages.json */
    slug: string
    /** Название темы: заголовок группы в /blog и текст ссылки в футере */
    title: string
    /** Призыв в конце статьи этого кластера */
    callToAction: string
    /** id статей блога, раскрывающих тему */
    articleIds: string[]
}

export const LANDING_CLUSTERS: LandingCluster[] = [
    {
        slug: 'free-sex-chat',
        title: 'Free sex chat',
        callToAction: 'Ready to try it yourself? Start a free sex chat — no registration, no sign up.',
        articleIds: [
            'what_is_sex_chat__types_benefits__how_to_start_easily',
            'sex_chat_in_the_modern_era__way_to_explore_online_intimacy',
            'welcome_to_the_new_era_of_desire',
        ],
    },
    {
        slug: 'adult-chat',
        title: 'Adult chat',
        callToAction: 'Want to see it in practice? Open an adult chat and meet people online right now.',
        articleIds: [
            'what_is_an_adult_chat_',
            'how_adult_chat_platforms_are_redefining_connections',
            'how_to_choose_an_online_adult_chat',
            'whats_the_difference_between_erotic_chat_and_sex_chat_',
        ],
    },
    {
        slug: 'virtual-sex-chat',
        title: 'Virtual sex chat',
        callToAction: 'Curious how it feels? Try a virtual sex chat and explore it for yourself.',
        articleIds: [
            'how_to_have_virtual_sex',
            'the_psychology_of_virtual_desire_why_we_love_adult_sex_chats',
            'from_text_to_video_choosing_the_right_type_of_online_sex_chat_for_you',
            'online_flirting_in_2025_why_sex_chats_are_overtaking_reallife_dating',
        ],
    },
    {
        slug: 'anonymous-chat',
        title: 'Anonymous chat',
        callToAction: 'Prefer to stay unrecognised? Start an anonymous chat — no email, no phone number.',
        articleIds: [
            'how_to_stay_safe_in_a_sex_chat_tips_for_beginners',
            'exploring_fetishes_safely_how_to_share_your_desires_in_adult_sex_chats',
            'couples_virtual_intimacy_how_online_sex_chats_can_spice_up_relationships',
            'top_10_personalities_youll_meet_in_18_sex_chats',
        ],
    },
    {
        slug: 'sexting',
        title: 'Sexting',
        callToAction: 'Ready to put it into words? Start sexting with someone who is up for it.',
        articleIds: [
            'the_dos_and_donts_of_erotic_sexting_in_18_chats',
            'roleplay_in_sex_chats_beginners_guide_to_unlocking_intense_pleasure',
            'top_5_fantasies_you_can_easily_explore_in_an_online_sex_chat',
        ],
    },
]

export function clusterBySlug(slug: string): LandingCluster | undefined {
    return LANDING_CLUSTERS.find(cluster => cluster.slug === slug)
}

export function clusterByArticleId(articleId: string): LandingCluster | undefined {
    return LANDING_CLUSTERS.find(cluster => cluster.articleIds.includes(articleId))
}
